export const GET_DIGITAL_REQUESTS = 'GET_DIGITAL_REQUESTS'
export const GET_DIGITAL_REQUEST = 'GET_DIGITAL_REQUEST'
export const UPDATE_DIGITAL_REQUEST = 'UPDATE_DIGITAL_REQUEST'
export const DELETE_DIGITAL_REQUEST = 'DELETE_DIGITAL_REQUEST'
